export const socialsData = {
    github: 'https://github.com/SameedHusayn/',
    facebook: 'https://www.facebook.com/SameedHusayn/',
    linkedIn: 'https://www.linkedin.com/in/syed-sameed-hussain/'
};